// Словарь интерфейса: en
const en = {
  "home": {
    "title": "Home",
    "description": "This is the home page of our website.",
    "branches": "Branches",
    "invoices": "Invoices",
    "warehouse": "Warehouse",
    "bonuses": "Bonuses",
    "terms": "Terms",
    "contacts": "Contacts",
    "parcels": "Parcels",
    "account": "Account",
    "calculator": "Calculator",
    "dashboard": "Control panel",
    "banner": "Banner"
  },
  "about": {
    "title": "About us",
    "description": "Learn more about our company."
  },
  "contact": {
    "title": "Contacts",
    "description": "Get in touch with us here."
  },
  "menu": {
    "instruction": "Instructions",
    "branches": "Branches",
    "warehouseAddress": "Warehouse address",
    "lostItems": "Lost items",
    "contacts": "Contacts",
    "copy": "Copy",
    "aboutUs": "About us",
    "prohibitedItems": "Items you cannot order",
    "home": "Home",
    "parcels": "Parcels",
    "profile": "Profile",
    "myParcels": "My parcels",
    "addTrack": "Add track",
    "archive": "Archive",
    "allParcels": "All parcels",
    "settings": "Settings",
    "username": "Client code (as in the delivery address)",
    "saveUsername": "Save",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "changePassword": "Change password",
    "close": "Close",
    "dashboard": "Control panel",
    "logout": "Log out",
    "about": "Description",
    "moreTrack": "All parcels",
    "passwd": "Password",
    "notifications": "Notifications"
  },
  "common": {
    "loading": "Loading...",
    "back": "Back",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "all": "All",
    "archive": "Archive",
    "next": "Next",
    "prev": "Back",
    "page": "Page {{page}} / {{total}}",
    "none": "—"
  },
  "account": {
    "title": "Account",
    "name": "Name:",
    "phone": "Phone:",
    "username": "Username:",
    "branch": "Branch:",
    "notSet": "not set",
    "password": "PASSWORD",
    "changePassword": "Change password",
    "logout": "Log out",
    "loadFail": "Could not load profile data.",
    "theme": "THEME",
    "themeAuto": "Auto",
    "themeLight": "Light",
    "themeDark": "Dark",
    "language": "LANGUAGE",
    "accent": "COLOR STYLE",
    "accentGreen": "Classic",
    "accentRed": "Red (like the app)",
    "accentBlue": "Blue",
    "accentPurple": "Purple",
    "accentOrange": "Orange",
    "accentTeal": "Teal",
    "accentPink": "Pink"
  },
  "parcels": {
    "title": "My parcels",
    "addTitle": "Add parcel",
    "trackPh": "Enter tracking number",
    "descPh": "Description (e.g. Zara jacket)",
    "fillAll": "Please fill in all fields",
    "notAuth": "User is not signed in",
    "added": "Bookmark added",
    "addError": "Failed to add the parcel",
    "archiveAll": "Archive all received",
    "archiveCount": "Archive {{count}} tracks?",
    "archiveBtn": "Archive",
    "toArchive": "Archive",
    "archiveOne": "Move to archive?",
    "archived": "Archived {{done}} of {{total}} tracks",
    "archivedOne": "Moved to archive",
    "noIssued": "No issued tracks",
    "deleteQ": "Delete this bookmark?",
    "deleted": "Bookmark deleted",
    "saved": "Bookmark saved",
    "noBookmarks": "No bookmarks",
    "noHistory": "No history",
    "showFull": "Show full history",
    "collapse": "Collapse history",
    "editTitle": "Edit bookmark",
    "trackNumber": "Tracking number",
    "description": "Description",
    "errArchive": "Failed to archive",
    "errLoad": "Failed to load bookmarks",
    "errDelete": "Failed to delete the bookmark",
    "errSave": "Failed to save the bookmark",
    "archiveAllTitle": "Archive all tracks",
    "archiveOneTitle": "Archive"
  },
  "auth": {
    "loginTitle": "Sign in",
    "loginSubtitle": "Enter your phone number and password",
    "login": "Sign in",
    "noAccount": "No account? Register",
    "forgot": "Forgot password?",
    "offer": "Public offer",
    "regTitle": "Registration",
    "name": "First name",
    "surname": "Last name (optional)",
    "usernamePh": "Client code — as in the address",
    "codeHint": "Your client code is provided by your branch representative in a private message.",
    "invitedBranch": "Branch: {{name}}",
    "referrerPh": "Referrer phone (optional)",
    "inviteNotice": "Registration requires a client code issued by your branch representative in a private message. Enter the code and the phone number it was sent to.",
    "chooseBranch": "Choose a branch",
    "passwordPh": "Create a password",
    "agree": "I agree to the processing of personal data and to the",
    "terms": "terms",
    "register": "Register"
  },
  "status": {
    "expected": "Expected",
    "arrivedWarehouse": "Arrived at warehouse",
    "sent": "Shipped",
    "arrivedBranch": "Arrived at branch",
    "arrivedAlmaty": "Arrived in Almaty",
    "issued": "Issued",
    "ready": "Ready for pickup",
    "inTransit": "In transit",
    "unknown": "Unknown"
  }
};

export default en;
